import PropTypes from 'prop-types';

import classNames from 'clsx';
import css from './collapsible-label.module.scss';

const CollapsibleLabel = ({
  shouldShowMore,
  onMoreInfoClick,
  moreText,
  lessText,
  labelStyle,
  className,
  caretClassName,
}) => (
  <button
    style={labelStyle}
    className={classNames(css.moreButton, className)}
    onClick={onMoreInfoClick}
    data-testid="profileMoreInfo"
  >
    <span>{shouldShowMore ? lessText : moreText}</span>
    <span
      className={classNames(css.caret, caretClassName, {
        [css.up]: shouldShowMore,
        [css.down]: !shouldShowMore,
      })}
      data-testid={shouldShowMore ? 'moreInfoChevronUp' : 'moreInfoChevronDown'}
    />
  </button>
);

CollapsibleLabel.propTypes = {
  shouldShowMore: PropTypes.bool.isRequired,
  onMoreInfoClick: PropTypes.func.isRequired,
  moreText: PropTypes.node.isRequired,
  lessText: PropTypes.node.isRequired,
  labelStyle: PropTypes.object,
  className: PropTypes.string,
  caretClassName: PropTypes.string,
};

export default CollapsibleLabel;
